const namespace = 'SALES_CHANNELS_CATEGORIES';

export const REQUEST_SALES_CHANNELS_CATEGORIES = `${namespace}/REQUEST_SALES_CHANNELS_CATEGORIES`;
export const RECEIVE_SALES_CHANNELS_CATEGORIES = `${namespace}/RECEIVE_SALES_CHANNELS_CATEGORIES`;
export const FAILURE_SALES_CHANNELS_CATEGORIES = `${namespace}/FAILURE_SALES_CHANNELS_CATEGORIES`;
